import * as actions from "./actionsType";

const initialData = {
  loading: false,
  mapaCarrera: [],
  mapaCarreraError: ""
};

export default function MapaCarreraReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_MAPA_CARRERA:
      return { ...state, loading: action.payload };


    case actions.GET_MAPA_CARRERA:
      return {
        ...state,
        mapaCarrera: action.payload.mapaCarrera
      };

    case actions.MAPA_CARRERA_FAIL:
      return { ...state, mapaCarreraError: action.payload };

    default:
      return state;
  }
}
